const checkDanger = () => import('@/pages/checkDanger/index')
const checkDangerCreate = () => import('@/pages/checkDanger/checkDangerCreate')
export default [{
  path: '/checkDanger',
  name: '/checkDanger',
  component: checkDanger,
  meta: {
    storeKey: 'trs.checkDanger'
  }
},
{
  path: '/checkDangerCreate',
  name: '/checkDangerCreate',
  component: checkDangerCreate,
  meta: {}
}
]



// WEBPACK FOOTER //
// ./src/router/checkDanger/index.js